module.exports = __webpack_public_path__ + "img/move2.6f063e9b.png";